import { componentQrl, inlinedQrl, _jsxBranch, useComputedQrl, useLexicalScope, _jsxC, _IMMUTABLE, _fnSignal } from "@builder.io/qwik";
import { Fragment } from "@builder.io/qwik/jsx-runtime";
import { getSizesForBreakpoints, getMaxWidthQueryForSize } from "../../../constants/device-sizes.qwik.mjs";
import { camelToKebabCase } from "../../../functions/camel-to-kebab-case.qwik.mjs";
import { createCssClass } from "../../../helpers/css.qwik.mjs";
import { checkIsDefined } from "../../../helpers/nullable.qwik.mjs";
import { InlinedStyles } from "../../inlined-styles.qwik.mjs";
const BlockStyles = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  _jsxBranch();
  const canShowBlock = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    const [props2] = useLexicalScope();
    const processedBlock = props2.block;
    if (checkIsDefined(processedBlock.hide))
      return !processedBlock.hide;
    if (checkIsDefined(processedBlock.show))
      return processedBlock.show;
    return true;
  }, "BlockStyles_component_canShowBlock_useComputed_YHoS9Lak9z4", [
    props
  ]));
  const css = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    var _a, _b, _c, _d, _e;
    const [props2] = useLexicalScope();
    const processedBlock = props2.block;
    const styles = processedBlock.responsiveStyles;
    const content = props2.context.content;
    const sizesWithUpdatedBreakpoints = getSizesForBreakpoints(((_a = content == null ? void 0 : content.meta) == null ? void 0 : _a.breakpoints) || {});
    const contentHasXSmallBreakpoint = Boolean((_c = (_b = content == null ? void 0 : content.meta) == null ? void 0 : _b.breakpoints) == null ? void 0 : _c.xsmall);
    const largeStyles = styles == null ? void 0 : styles.large;
    const mediumStyles = styles == null ? void 0 : styles.medium;
    const smallStyles = styles == null ? void 0 : styles.small;
    const xsmallStyles = styles == null ? void 0 : styles.xsmall;
    const className = processedBlock.id;
    if (!className)
      return "";
    const largeStylesClass = largeStyles ? createCssClass({
      className,
      styles: largeStyles
    }) : "";
    const mediumStylesClass = mediumStyles ? createCssClass({
      className,
      styles: mediumStyles,
      mediaQuery: getMaxWidthQueryForSize("medium", sizesWithUpdatedBreakpoints)
    }) : "";
    const smallStylesClass = smallStyles ? createCssClass({
      className,
      styles: smallStyles,
      mediaQuery: getMaxWidthQueryForSize("small", sizesWithUpdatedBreakpoints)
    }) : "";
    const xsmallStylesClass = xsmallStyles && contentHasXSmallBreakpoint ? createCssClass({
      className,
      styles: xsmallStyles,
      mediaQuery: getMaxWidthQueryForSize("xsmall", sizesWithUpdatedBreakpoints)
    }) : "";
    const hoverAnimation = processedBlock.animations && processedBlock.animations.find((item) => item.trigger === "hover");
    let hoverStylesClass = "";
    if (hoverAnimation) {
      const hoverStyles = ((_e = (_d = hoverAnimation.steps) == null ? void 0 : _d[1]) == null ? void 0 : _e.styles) || {};
      hoverStylesClass = createCssClass({
        className: `${className}:hover`,
        styles: {
          ...hoverStyles,
          transition: `all ${hoverAnimation.duration}s ${camelToKebabCase(hoverAnimation.easing)}`,
          transitionDelay: hoverAnimation.delay ? `${hoverAnimation.delay}s` : "0s"
        }
      }) || "";
    }
    return [
      largeStylesClass,
      mediumStylesClass,
      smallStylesClass,
      xsmallStylesClass,
      hoverStylesClass
    ].join(" ");
  }, "BlockStyles_component_css_useComputed_b9Ru8qTcNik", [
    props
  ]));
  return /* @__PURE__ */ _jsxC(Fragment, {
    children: css.value && canShowBlock.value ? /* @__PURE__ */ _jsxC(InlinedStyles, {
      id: "builderio-block",
      get styles() {
        return css.value;
      },
      get nonce() {
        return props.context.nonce;
      },
      [_IMMUTABLE]: {
        id: _IMMUTABLE,
        nonce: _fnSignal((p0) => p0.context.nonce, [
          props
        ], "p0.context.nonce"),
        styles: _fnSignal((p0) => p0.value, [
          css
        ], "p0.value")
      }
    }, 3, "8B_0") : null
  }, 1, "8B_1");
}, "BlockStyles_component_0lZeirBI638"));
export {
  BlockStyles,
  BlockStyles as default
};
